/* pr-popup.js - 10%-off welcome popup + persistent shaking teaser (ported 1:1 from popupdemo.html).
   Wires the SSR markup from snippets/home-popup.liquid. Real Shopify subscribe via NATIVE form POST to a
   hidden iframe (captcha-safe - a programmatic form.submit() would bypass the storefront captcha hook and be
   rejected). "Shop now & save" only closes (never navigates). Replaces cro.js Module 7. Loaded site-wide. */
(function () {
  'use strict';
  if (window.__prPop) return; window.__prPop = true;
  function start() {
    var d = document, body = d.body, byId = function (id) { return d.getElementById(id); };
    var teaser = byId('teaser'), pop = byId('pop'), card = byId('popCard'), scrim = byId('scrim');
    if (!teaser || !pop || !card) return;   // markup absent -> nothing to wire
    // Relocate the popup UI to <body> so it's never nested in (and hidden with) the old #MainContent on the
    // homepage, and so its fixed positioning is viewport-relative regardless of any container-type ancestor.
    var sink = d.querySelector('iframe[name="pr_pop_sink"]');
    [scrim, teaser, pop, sink].forEach(function (el) { if (el && el.parentElement !== body) body.appendChild(el); });
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* teaser shake: every 5s while the popup is closed, plus one early wobble ~1.2s after load */
    function shakeTick() {
      if (reduce || teaser.classList.contains('is-hidden')) return;
      if (body.classList.contains('pop-open')) return;
      teaser.classList.remove('is-shaking'); void teaser.offsetWidth; teaser.classList.add('is-shaking');
    }
    setInterval(shakeTick, 5000);
    setTimeout(shakeTick, 1200);
    // Keep the teaser ABOVE any bottom sticky bar (product-page ATC, homepage ATC) so it's never covered;
    // it lifts up when a bar appears and animates back down when the bar goes away.
    function _base() { return window.matchMedia('(max-width:600px)').matches ? 14 : 22; }
    function _bottomBar() {
      var sels = ['.pdp-sticky', '.hm-sticky', '.ccx-sticky'];
      for (var i = 0; i < sels.length; i++) {
        var el = d.querySelector(sels[i]); if (!el) continue;
        var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') < 0.1) continue;
        var r = el.getBoundingClientRect();
        if (r.height > 10 && r.bottom >= window.innerHeight - 6 && r.top < window.innerHeight - 6) return r;
      }
      return null;
    }
    function _updateLift() { var bar = _bottomBar(); teaser.style.bottom = (bar ? Math.round(window.innerHeight - bar.top + _base()) : _base()) + 'px'; }
    window.addEventListener('scroll', _updateLift, { passive: true });
    window.addEventListener('resize', _updateLift);
    setInterval(_updateLift, 500);   // catch the sticky bar toggling (it's IntersectionObserver-driven)
    _updateLift();

    var lastFocus = null;
    function openPop() {
      lastFocus = d.activeElement;
      body.classList.add('pop-open');
      pop.setAttribute('aria-hidden', 'false');
      setTimeout(function () { var e = byId('popEmail'); if (e && !card.classList.contains('is-done')) e.focus(); }, 340);
    }
    function closePop() {
      body.classList.remove('pop-open');            // the shaking teaser always returns
      pop.setAttribute('aria-hidden', 'true');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
    }
    teaser.addEventListener('click', openPop);
    ['popClose', 'popDecline', 'popShop'].forEach(function (id) { var el = byId(id); if (el) el.addEventListener('click', closePop); });
    if (scrim) scrim.addEventListener('click', closePop);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('pop-open')) closePop(); });

    /* form -> real subscribe (native POST to hidden iframe) + reveal STEADY10 */
    var form = byId('popForm'), email = byId('popEmail'), field = byId('popField'), errM = byId('popErr');
    var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form && email) {
      form.addEventListener('submit', function (e) {
        if (!ok.test((email.value || '').trim())) {
          e.preventDefault();
          if (field) field.classList.add('err'); if (errM) errM.classList.add('show'); email.focus(); return;
        }
        /* valid: let Shopify's captcha hook obtain a token and submit top-level to /contact. The storefront
           REJECTS any post without a captcha token ("Missing CAPTCHA token"), so background/iframe posts never
           subscribe. Flag it and reveal the code only when we return with customer_posted=true. */
        if (field) field.classList.remove('err'); if (errM) errM.classList.remove('show');
        try { localStorage.setItem('prNewsPending', '1'); } catch (x) {}
        /* loading state on the button while Shopify verifies + the page hands off */
        var sb = form.querySelector('.pop__submit');
        if (sb && !sb.classList.contains('is-loading')) {
          var orig = sb.innerHTML;
          sb.classList.add('is-loading');
          sb.innerHTML = '<span class="pop__spin" aria-hidden="true"></span>Unlocking your 10% off…';
          setTimeout(function () { if (sb.classList.contains('is-loading')) { sb.classList.remove('is-loading'); sb.innerHTML = orig; } }, 15000);
        }
      });
      email.addEventListener('input', function () { if (field) field.classList.remove('err'); if (errM) errM.classList.remove('show'); });
    }

    /* copy the code */
    var codeBtn = byId('popCode');
    if (codeBtn) codeBtn.addEventListener('click', function () {
      var tEl = byId('popCodeText'); if (!tEl) return;
      var t = tEl.textContent.trim();
      var done = function () { codeBtn.classList.add('copied'); var cp = byId('popCp'); if (cp) cp.textContent = 'Copied ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(done, done);
      else { var ta = d.createElement('textarea'); ta.value = t; d.body.appendChild(ta); ta.select(); try { d.execCommand('copy'); } catch (x) {} d.body.removeChild(ta); done(); }
    });

    /* Returned from a successful Shopify newsletter submit (popup OR footer) -> reveal the code now, only
       after Shopify actually accepted the signup (?customer_posted=true) and we flagged the submit. */
    (function () {
      if ((location.search || '').indexOf('customer_posted=true') === -1) return;
      var pending = false; try { pending = !!localStorage.getItem('prNewsPending'); } catch (x) {}
      if (!pending) return;
      try { localStorage.removeItem('prNewsPending'); } catch (x) {}
      card.classList.add('is-done');
      openPop();
      try { var u = new URL(location.href); u.searchParams.delete('customer_posted'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (x) {}
    })();
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();
